export const traductionsKeysEnum = {
    ADD_TO_CART: "ADD_TO_CART",
    AFTER: "AFTER",
    AVAILABLE_FROM: "AVAILABLE_FROM",
    AVAILABLE_UNTIL: "AVAILABLE_UNTIL",
    BACK_TO_SCHEDULE: "BACK_TO_SCHEDULE",
    BEFORE: "BEFORE",
    BROADCAST_ATTRIBUTE: "BROADCAST_ATTRIBUTE",
    BROADCAST_DATE: "BROADCAST_DATE",
    BROADCAST_STATUS: "BROADCAST_STATUS",
    BUDGET: "BUDGET",
    CANCEL: "CANCEL",
    CAMPAIGNS: "CAMPAIGNS",
    CAMPAIGN_CODE: "CAMPAIGN_CODE",
    CAMPAIGN_NAME: "CAMPAIGN_NAME",
    CAMPAIGN_PRICE: "CAMPAIGN_PRICE",
    CAMPAIGN_TYPE: "CAMPAIGN_TYPE",
    CART: "CART",
    CGRP_GROSS: "CGRP_GROSS",
    CHANNEL: "CHANNEL",
    CHANNELS: "CHANNELS",
    CHECK_ALL: "CHECK_ALL",
    CLEAN: "CLEAN",
    CLOSE: "CLOSE",
    CLOSED : "CLOSED", 
    COLOR_TEXT_SEQUENCE: "COLOR_TEXT_SEQUENCE",
    COMMENT: "COMMENT",
    CONFIRM_DELETE_SELECTIONS: "CONFIRM_DELETE_SELECTIONS",
    CPM_MAJORE: "CPM_MAJORE",
    CPM_NET: "CPM_NET",
    CREATION_DATE: "CREATION_DATE",
    CURRENT_LOGO: "CURRENT_LOGO",
    CURRENT_PDF: "CURRENT_PDF",
    CUSTOMER: "CUSTOMER",
    CUSTOMER_ID: "CUSTOMER_ID",
    CUSTOMER_NAME: "CUSTOMER_NAME",
    CUSTOMERS: "CUSTOMERS",
    DATE: "DATE",
    DAY: "DAY",
    DETAIL_SCREEN: "DETAIL_SCREEN",
    DETAILS_SCREEN_TYPE: "DETAILS_SCREEN_TYPE",
    DISPLAY_MODE: "DISPLAY_MODE",
    DONT_MAJO: "DONT_MAJO",
    DONT_NEGO: "DONT_NEGO",
    DOWNLOAD_LOGO: "DOWNLOAD_LOGO",
    DOWNLOAD_PDF: "DOWNLOAD_PDF",
    DURATION: "DURATION",
    DURATION_REQUIRED: "DURATION_REQUIRED",
    EDITABLE: "EDITABLE",
    END_CAMPAIGN: "END_CAMPAIGN",
    END_DATE: "END_DATE",
    END_DATE_SHOULD_BE_AFTER_START_DATE: "END_DATE_SHOULD_BE_AFTER_START_DATE",
    ENDS: "ENDS",
    ERROR_MARKETING_DATE_PASSED: "ERROR_MARKETING_DATE_PASSED",
    EXCLUDED_SECTORS: "EXCLUDED_SECTORS",
    FIXED_SPOT_DURATION: "FIXED_SPOT_DURATION",
    FORMAT: "FORMAT",
    FREE_SPACE: "FREE_SPACE",
    FRIDAY : "FRIDAY", 
    FULLY_AVAILABLE_SPACE: "FULLY_AVAILABLE_SPACE",
    GROUP_SEQUENCES: "GROUP_SEQUENCES",
    GRP_INDEX: "GRP_INDEX",
    ID_SEQUENCE: "ID_SEQUENCE",
    IMPRESSIONS_A_DELIVRER: "IMPRESSIONS_A_DELIVRER",
    INDICE: "INDICE",
    INFOS_SUPPLEMENTAIRES: "INFOS_SUPPLEMENTAIRES",
    INTERMEDIATE: "INTERMEDIATE",
    INVALID_END_DATE: "",
    INVALID_START_DATE : "",
    INVENTAIRE : "INVENTAIRE", 
    ITEM_COMMAND: "ITEM_COMMAND",
    ITEMS: "ITEMS",
    LOGO_REQUIRED: "LOGO_REQUIRED",
    MAJ: "MAJ",
    MARKETING: "MARKETING",
    MESSAGE_ERROR_SLOTS: "MESSAGE_ERROR_SLOTS",
    MODIFICATION_DATE: "MODIFICATION_DATE",
    MONDAY : "MONDAY", 
    NATURE_ABBREVIATES: "NATURE_ABBREVIATES",
    NATURE_NUMBER: "NATURE_NUMBER",
    NB_FREE_SPOTS: "NB_FREE_SPOTS",
    NB_SPOTS: "NB_SPOTS",
    NB_SPOTS_OPTION: "NB_SPOTS_OPTION",
    NB_SPOTS_RESERVED: "NB_SPOTS_RESERVED",
    NEGOTIATE_CPM: "NEGOTIATE_CPM",
    NEGOTIATION: "NEGOTIATION",
    NO_LOGO_CURRENTLY: "NO_LOGO_CURRENTLY",
    NO_PDF_CURRENTLY: "NO_PDF_CURRENTLY",
    NUMBER_OF_SPOTS: "NUMBER_OF_SPOTS",
    NUMBER_OF_SPOTS_FOR_TRAILERS: "NUMBER_OF_SPOTS_FOR_TRAILERS",
    NUMBER_POSSIBLE_DAYS_ADDITION: "NUMBER_POSSIBLE_DAYS_ADDITION",
    NUMBER_POSSIBLE_DAYS_SUBTRACTION: "NUMBER_POSSIBLE_DAYS_SUBTRACTION",
    OF: "OF",
    OF_NATURE: "OF_NATURE",
    ONLY_NUMBERS: "ONLY_NUMBERS",
    OPEN : "OPEN",  
    OPERATION: "OPERATION",
    OPERATION_TYPE: "OPERATION_TYPE",
    ORDER_STATUS: "ORDER_STATUS",
    ORDERS : "ORDERS",
    PACK_DURATION: "PACK_DURATION",
    PACK_LIST: "PACK_LIST",
    PACK_NAME: "PACK_NAME",
    PAIRING_CODE:"PAIRING_CODE",
    PARTIALLY_AVAILABLE_SPACE:"PARTIALLY_AVAILABLE_SPACE",
    PERCENTAGE:"PERCENTAGE",
    PERCENTAGE_OF:"PERCENTAGE_OF",
    PERIOD: "PERIOD",
    PREFERENCE_POS: "PREFERENCE_POS",
    PREFERENCE_TYPE:"PREFERENCE_TYPE",
    PRICE: "PRICE",
    PRICE_DETAIL: "PRICE_DETAIL",
    PRICE_REQUIRED: "PRICE_REQUIRED",
    PROGRAM: "PROGRAM",
    PROGRAMS: "PROGRAMS",
    PROGRESS:"PROGRESS",
    PROJECTS: "PROJECTS",
    PROJECT_SUBTITLE : "PROJECT_SUBTITLE",
    RANK: "RANK",
    RATE_USED: "RATE_USED",
    RATED_DURATION: "RATED_DURATION",
    REMAINING_SPACE_SCREENS:"REMAINING_SPACE_SCREENS",
    REMAINING_TIME: "REMAINING_TIME",
    REQUIRED_PACK_NAME: "REQUIRED_PACK_NAME",
    RESERVATION: 'ReservIA',
    SALES_SUPPORT : "SALES_SUPPORT",
    SATURDAY : "SATURDAY",  
    SCREEN_BACKUP: "SCREEN_BACKUP",
    SCREEN_BACKUP_TOTAL: "SCREEN_BACKUP_TOTAL",
    SCREEN_NUMBER: "SCREEN_NUMBER",
    SCREEN_NUMBER_TOTAL: "SCREEN_NUMBER_TOTAL",
    SCREEN_TEXT:"SCREEN_TEXT",
    SECONDES: "SECONDES",
    SECTOR_CODE:"SECTOR_CODE",
    SECTORS_INCLUDED:"SECTORS_INCLUDED",
    SECTOR_SPOT_CODE:"SECTOR_SPOT_CODE",
    SECTOR_RESEARCH:"SECTOR_RESEARCH",
    SEGMENTS : "SEGMENTS",
    SEGMENTS_ADD : "SEGMENTS_ADD",
    SEGMENTS_PLACEHOLDER_AGE: "SEGMENTS_PLACEHOLDER_AGE",
    SEGMENTS_PLACEHOLDER_CONSO_TV: "SEGMENTS_PLACEHOLDER_CONSO_TV",
    SEGMENTS_PLACEHOLDER_CSP: "SEGMENTS_PLACEHOLDER_CSP",
    SEGMENTS_PLACEHOLDER_GENRE: "SEGMENTS_PLACEHOLDER_GENRE",
    SEGMENTS_PLACEHOLDER_INTERESTS: "SEGMENTS_PLACEHOLDER_INTERESTS",
    SEGMENTS_PLACEHOLDER_MOMENT: "SEGMENTS_PLACEHOLDER_MOMENT",
    SEGMENTS_PLACEHOLDER_PMGTV :"SEGMENTS_PLACEHOLDER_PMGTV",
    SEGMENTS_PLACEHOLDER_PROFIL: "SEGMENTS_PLACEHOLDER_PROFIL",
    SEQUENCES: "SEQUENCES",
    SHOW: "SHOW",
    SPACE_COMPLETELY_UNAVAILABLE: "SPACE_COMPLETELY_UNAVAILABLE",
    SPECIAL_CHARACTERS_NOT_ALLOWED: "SPECIAL_CHARACTERS_NOT_ALLOWED",
    SPOT: "SPOT",
    SPOT_DURATION: "SPOT_DURATION",
    SPOT_PRICE: "SPOT_PRICE",
    START_CAMPAIGN: "START_CAMPAIGN",
    START_DATE: "START_DATE",
    START_ON: "START_ON",
    STATUS: "STATUS",
    STATUT: "STATUT",
    STATUT_DATE: "STATUT_DATE",
    STOCK_STATUS : "STOCK_STATUS",  
    SUNDAY : "SUNDAY",  
    TARGET_AUDIENCE: "TARGET_AUDIENCE",
    TECHNICAL_CONDITION: "TECHNICAL_CONDITION",
    THURSDAY : "THURSDAY", 
    TIME_FILTERS: "TIME_FILTERS",
    TO: "TO",
    TO_VALIDATE: "TO_VALIDATE",
    TOTAL_DURATION: "TOTAL_DURATION",
    TRAILER_TYPE: "TRAILER_TYPE",
    TUESDAY : "TUESDAY",  
    UNCHECK_ALL: "UNCHECK_ALL",
    UPDATE: "UPDATE",
    VALEUR_CARBONE: "VALEUR_CARBONE",
    WEDNESDAY : "WEDNESDAY",      
    WEEK: "WEEK",
    YES: "YES",
 } as const;